import { navEvents } from "../../template-parts/global/main-menu/js/menu-events.js";
import { videoEvents } from "../../template-parts/global/video/js/video-events.js";
import { initStickyHeader } from "../../template-parts/header/default/js/header.js";
import { sidebarEvents } from "../../template-parts/sidebar/default/js/sidebar-events.js";
import { beforeAfterEvents } from "../../template-parts/global/before-after/js/before-after-events.js";
import { packagesEvents } from "../../template-parts/global/packages/secondary/js/package-events.js";
import { formEvents } from "../../template-parts/global/form/js/form-events.js";
import { animationEvents } from "../../template-parts/global/animations/animation-events.js";
//import { sliderEvents } from "../../template-parts/global/slider/js/slider-events.js";
import { continuousSliderEvents } from "../../template-parts/global/continuous-slider/js/continuous-slider-events.js";
import { sliderEventsOnScroll } from "../../template-parts/global/slider/js/slider-event-intersection-observer.js";
import { sectionTechnologyEvents } from "../../template-parts/sections/section-technology/default/js/section-technology-events.js";
import { bookingEvents } from "../../template-parts/global/bookings/js/booking-events.js";
import { tabEvents } from "../../template-parts/global/tabs/js/tabs-events.js";
import { svgEvents } from "../../template-parts/global/load-svg-icons/js/load-svg-events.js";
import { alertBarEvents } from "../../template-parts/global/alert-bar/default/js/alert-bar-events.js";

document.addEventListener("DOMContentLoaded", () => {
	alertBarEvents();
	initStickyHeader();
	navEvents();
	animationEvents();
	sliderEventsOnScroll(); // i could go even further and look for these elements before dynamically importing events
	//sliderEvents(); // i could go even further and look for these elements before dynamically importing events
	sidebarEvents(); //  i could go even further and look for these elements before dynamically importing events
	packagesEvents(); //  i could go even further and look for these elements before dynamically importing events
	beforeAfterEvents(); //  i could go even further and look for these elements before dynamically importing events
	formEvents();
	continuousSliderEvents();
	sectionTechnologyEvents();
	// only run videos on the page that are not in a slider. slider videos load sliderVideoEvents() after slider init in cloned-slides.js
	const videos = document.querySelectorAll("div:not([data-acf-template]) > .ilawyer-video");
	videoEvents(videos); //  i could go even further and look for these elements before dynamically importing events
	bookingEvents();
	tabEvents();
	svgEvents();
	//alertBarEvents();
});
